import React, { useEffect, useState } from 'react';
import { useHistory } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { useDebounce } from 'use-debounce';
import { useForm } from 'react-hook-form';
import { AddProductModal, shopifyBody, shopifyHead } from './fragments';
import { shopifyActions } from 'store';
import { AddInviteButton, CheckboxMain, InputMain } from 'components';
import { Images } from 'assets/images';
import { ShopifyMap } from './fragments/shopifyMap';
import { httpRequestsOnLoadActions } from '../../store/http_requests_on_load';
import { SavePage, useModal } from 'utils';

export const ShopifyMapPage = () => {
    const [noPriceList, setNoPriceList] = useState(false);
    const [search, setSearch] = useState(null);
    const [searchValue] = useDebounce(search, 500);
    const { shopifyProducts } = useSelector((state) => ({
        shopifyProducts: state.shopify.shopifyProducts,
    }));
    const dispatch = useDispatch();
    const history = useHistory();
    const { control, watch } = useForm();
    const { open } = useModal();
    const searchErply = watch('search');
    const [erplyCode] = useDebounce(searchErply, 500);
    const info = history?.location?.state;

    useEffect(() => {
        const loader = noPriceList || searchValue?.value ? 'noLoad' : 'loading';

        const filteredInfo = {
            ...info,
        };
        delete filteredInfo.page;
        if (noPriceList) filteredInfo.noPriceList = noPriceList;

        dispatch(shopifyActions.getShopify({
            ...filteredInfo,
            erplyCode, ...searchValue,
        }, loader, searchValue?.searchKey));
    }, [erplyCode, searchValue, info, noPriceList]);

    const renderTableValues = {
        head: shopifyHead,
        body: shopifyBody,
        actionType: 'GET_SHOPIFY',
        list: shopifyProducts?.mappings,
        count: shopifyProducts?.count,
    };

    const handleSearchReq = (value, name) => {
        SavePage(history);

        setSearch({
            [name]: value,
        });
    };

    const renderParams = () => {
        const filteredInfo = {
            ...info,
        };
        delete filteredInfo.page;
        delete filteredInfo.tab;

        if (searchValue?.value) {
            filteredInfo[searchValue?.searchKey] = searchValue?.value;
        }
        if (!searchValue?.value) {
            dispatch(httpRequestsOnLoadActions.removeLoading(searchValue?.searchKey));
            delete filteredInfo[searchValue?.searchKey];
        }
        return filteredInfo;
    };


    return (
        <div>
            <div className='shopify-map-input-button-wrapper'>
                <div className='flex' style={{ width: '100%', gap: 42 }}>
                    <CheckboxMain
                        label='Missing Erply Pricing'
                        value={noPriceList}
                        onChange={(e) => {
                            setNoPriceList(e?.target?.checked);
                        }}
                    />
                    <InputMain
                        className='search-erply-input'
                        placeholder='Search by Erply Code...'
                        name='search'
                        control={control}
                        showError={false}
                        type={'search'}
                        startAdornment={<Images.SearchNormalSvg />}
                    />
                </div>

                <AddInviteButton text={'Add Product Code'} handleClick={() => open(<AddProductModal />)} />
            </div>

            <ShopifyMap
                renderParams={renderParams}
                head={renderTableValues?.head}
                body={renderTableValues?.body}
                loadingType={renderTableValues?.actionType}
                type={'map'}
                list={renderTableValues?.list}
                listCount={renderTableValues?.count}
                handleSearchReq={handleSearchReq}
            />
        </div>
    );
};

